import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Grid from "@mui/material/Grid";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { StyledChip } from "components/StyledChip";
import { StyledChips } from "components/StyledChips";
import { intlFormatDateWithWeekday } from "helpers";
import { ServiceHistory } from "operations/schema/schema";
import { JobStyles } from "styles/JobStyles";

const classes = JobStyles.createClasses();
const StyledBox = JobStyles.defineStyles(classes);

interface HistoryProps {
  svcHistory: ServiceHistory;
  loading?: boolean;
  toLink?: string;
}

export const HistoryItem: FC<HistoryProps> = (props) => {
  const { svcHistory, toLink } = props;
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <StyledBox borderLeft={0} borderColor="grey.500">
      <ListItem
        button
        divider
        component="div"
        onClick={() =>
          navigate(`${toLink}/${svcHistory.serviceJobId}`, {
            state: { svcHistory: svcHistory },
          })
        }
        key={svcHistory.serviceJobId}
        data-testid="HistoryItem"
      >
        <Grid container alignItems="center" wrap="nowrap">
          <Grid item xs={11} width="100%">
            <Grid item container className={classes.jobTime} direction="row" alignItems="center">
              <Typography className={classes.date}>
                {intlFormatDateWithWeekday(intl, svcHistory.completedDate)}
              </Typography>
            </Grid>
            <Typography variant="body1">
              <span>{svcHistory.technicianName}</span>
            </Typography>
            <Typography variant="body1">
              <span>{svcHistory.externalId}</span>
            </Typography>
            {svcHistory.customerName && (
              <Typography variant="body1">
                <span>{svcHistory.customerName}</span>
              </Typography>
            )}
            {svcHistory.machine?.modelDescription && (
              <Typography variant="body1">{svcHistory.machine.modelDescription}</Typography>
            )}
            {svcHistory.machine?.modelType && (
              <Typography variant="body1">{svcHistory.machine.modelType}</Typography>
            )}
            {svcHistory.machine?.machineNo && (
              <Typography variant="body2" color="secondary">
                {svcHistory.machine.machineNo}
              </Typography>
            )}
            {svcHistory.machine?.location && (
              <Typography variant="body2" color="secondary" className={classes?.paragraph}>
                {svcHistory.machine.location}
              </Typography>
            )}
            <Typography
              variant="body2"
              component={"span"}
              className={`${classes.ellipsis} ${classes.paragraph} truncated`}
              mt={1}
            >
              {svcHistory.symptomDescription}
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              className={`${classes.ellipsis} ${classes.paragraph}`}
              mt={1}
            >
              {svcHistory.actionCodes?.map((ac) => (
                <StyledChip key={ac} label={ac} />
              ))}
            </Typography>
            <StyledChips symptoms={svcHistory.symptoms} priority={svcHistory.priority} />
          </Grid>

          <Grid item xs={1}>
            <ChevronRightIcon />
          </Grid>
        </Grid>
      </ListItem>
    </StyledBox>
  );
};
